// context/AuthorPostsContext.js
import { createContext, useContext } from "react";

const AuthorPostsContext = createContext(null);

/* value shape: { openAuthorPosts(user), closeAuthorPosts(), renderAuthorPosts() }
   Provided once in GroupChat.js (where feedSocket/feedActionSocket/users/etc.
   already live) so UserInfoOverlay can open an author's posts and render
   them in place, instead of needing all of MyPost's props threaded through
   every layout in between. */
export function AuthorPostsProvider({ value, children }) {
  return (
    <AuthorPostsContext.Provider value={value}>
      {children}
    </AuthorPostsContext.Provider>
  );
}

export function useAuthorPosts() {
  return useContext(AuthorPostsContext) || {};
}